import { Box, Button, Heading, HStack, Icon, } from "@chakra-ui/react";
import { Link as RouterLink, } from "react-router-dom";
import { RoutesMap, } from "../../routes.tsx";
import { ChevronRightIcon, } from "@heroicons/react/24/outline";
import { LimitCardPreview, LimitPageHeader, LimitMainInfo, PaymentList, } from "../../components/features/LimitPage";

export function LimitPage() {
  return (
    <div>
      <Box py={2}>
        <LimitPageHeader />
      </Box>
      <Box py={4}>
        <LimitCardPreview />
      </Box>
      <Box py={4}>
        <LimitMainInfo />
      </Box>
      <Box py={4}>
        <PaymentList />
      </Box>
      <Box py={4}>
        <HStack mb={2}>
          <Heading flex="1" size="md">Ваши покупки</Heading>
          <Button
            as={RouterLink}
            to={RoutesMap.operations.index}
            variant="link"
            colorScheme="gray"
            rightIcon={<Icon color="sceondary" as={ChevronRightIcon} />}
          >
            Все
          </Button>
        </HStack>
      </Box>
    </div>
  );
}

LimitPage.loader = () => {
  // await prepareUnleashClient();
  // if (!unleashClient.isEnabled("operations.history",)) {
  //   return redirect(RoutesMap.index,);
  // }
  return null;
};
